import {DashboardPathEntry} from "@/shared/timr";

declare type AnchorClickHandler = (e: JQuery.TriggeredEvent, anchorData: number) => void

export interface DashboardFilterPathConfig {
	currentFilterPathElement: JQuery;
	onFilterPathElementClick: AnchorClickHandler;
	currentFilterPathRootMessage: string;
}

export class DashboardFilterPath {

	constructor(private readonly config: DashboardFilterPathConfig) {
	}

	public updateDashboardInfo(info: { description?: string; path?: DashboardPathEntry[] }) {
		const root = this.config.currentFilterPathElement;
		root.empty();
		this.addPathAnchor(root, 0, this.config.currentFilterPathRootMessage, this.config.onFilterPathElementClick);
		if (info.path) {
			info.path.forEach((task, index) => {
				if (index === info.path.length - 1) {
					root.append($("<li></li>").text(task.taskName).addClass("active"));
				} else {
					this.addPathAnchor(root, task.id, task.taskName, this.config.onFilterPathElementClick);
				}
			});
		} else if (info.description) {
			root.append($("<li></li>").text(info.description).addClass("active"));
		}
	}

	private addPathAnchor(root: JQuery, anchorData: number, anchorName: string, onAnchorClick: AnchorClickHandler) {
		$("<a></a>")
			.attr("href", "#")
			.text(anchorName)
			.click((e) => {
				onAnchorClick(e, anchorData);
			})
			.wrap("<li></li>")
			.parent()
			.appendTo(root);
	}
}
